import { Injectable, OnDestroy } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import { from, Observable, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { mutation, subscription, subscriptionForLikes } from './graphql';

import { commentList } from '../../../utils/constants';
import { BrowserStorageService } from '../common/browser-storage.service';

@Injectable({ providedIn: 'root' })
export class AppSyncService implements OnDestroy {
  private subscriptions: Subscription[] = [];
  private subscriptionsForLike: Subscription[] = [];
  private client = generateClient();
  adminDetail: any;
  constructor(private _storageService: BrowserStorageService) {
    Amplify.configure({
      API: {
        GraphQL: {
          endpoint: environment.appsyncEndpoint as string,
          defaultAuthMode: 'lambda', // or 'apiKey'
        },
      },
    });
  }
  getActivities(postId: string, limit: number = 20, nextToken?: string): Promise<any> {
    var queryList: any = `query MyQuery {
      getComments(limit: 20, postId:\"${postId}\",nextToken:${nextToken}) {
       ${commentList}
        }
    }`;
    return this.client.graphql({
      query: queryList,
      variables: { postId, limit, nextToken },
      authMode: 'lambda', // or 'apiKey' depending on your auth mode
      authToken: environment.authToken, // Your authorization token
      // Alternatively, you can use headers directly
    }) as Promise<any>;
  }
  /** Mutations **/
  addComment(comment: string, postId: string, userId: string): Promise<any> {
    return this.client.graphql({
      query: mutation,
      variables: { comment, postId, userId },
      authMode: 'lambda', // or 'apiKey' depending on your auth mode
      authToken: environment.authToken, // Your authorization token
      // Alternatively, you can use headers directly
    }) as Promise<any>;
  }
  /** Subscriptions **/
  subscribeToComments(postId: string, userId: string): Observable<any> {
    return new Observable((observer) => {
      const sub = from(
        this.client.graphql({
          query: subscription,
          variables: { postId, userId },
          authMode: 'lambda', // or 'apiKey' depending on your auth mode
          authToken: environment.authToken, // Your authorization token
        }),
      ).subscribe({
        next: (data: any) => observer.next(data),
        error: (error) => observer.error(error),
      });

      this.subscriptions.push(sub as unknown as Subscription);
    });
  }
  /** Subscriptions **/
  subscribeToLike(postId: string, userId: string): Observable<any> {
    return new Observable((observer) => {
      const sub = from(
        this.client.graphql({
          query: subscriptionForLikes,
          variables: { postId, userId },
          authMode: 'lambda', // or 'apiKey' depending on your auth mode
          authToken: environment.authToken, // Your authorization token
        }),
      ).subscribe({
        next: (data: any) => observer.next(data),
        error: (error) => observer.error(error),
      });

      this.subscriptionsForLike.push(sub as unknown as Subscription);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptionsForLike.forEach((sub) => sub.unsubscribe());
  }

  getGraphqlEndpoint(): string {
    return environment.appsyncEndpoint as string;
  }

  getApiKey(): string {
    return environment.apiKey as string;
  }
}
